import React, { Component } from "react";

import { defined } from "@formant/core/common/defined";
import { IDeviceConfigurationTemplate } from "@formant/core/model/IDeviceConfigurationTemplate";

import {
    appStore,
    deviceConfigurationTemplateStore,
    eventTriggerStore,
    routerStore,
} from "../../../stores";
import { Buttons } from "../../common/Buttons";
import {
    IMultiActionButtonAction,
    MultiActionButton,
} from "../../Observe/MultiActionButton";

export interface IActionsProps {
    deviceConfigurationTemplate: IDeviceConfigurationTemplate;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        const { onClone, onDelete, onApply } = this;
        const actions: IMultiActionButtonAction[] = [
            {
                icon: "delete",
                label: "Remove",
                onSelect: onDelete,
            },
            {
                icon: "clone",
                label: "Clone",
                onSelect: onClone,
            },
            {
                icon: "play",
                label: "Apply",
                onSelect: onApply,
            },
        ];
        return (
            <Buttons>
                <MultiActionButton actions={actions} />
            </Buttons>
        );
    }

    private onClone = async () => {
        const { navigate, routeTo } = routerStore;
        await navigate(
            routeTo.cloneDeviceConfigurationTemplate({
                id: defined(this.props.deviceConfigurationTemplate.id),
            }),
        );
    };

    private onDelete = async () => {
        const { deviceConfigurationTemplate } = this.props;
        const { name, id } = deviceConfigurationTemplate;
        const eventTriggers = await eventTriggerStore.fetchList();
        const usedBy = eventTriggers.filter(
            eventTrigger =>
                eventTrigger.enabled &&
                eventTrigger?.triggeredConfiguration &&
                eventTrigger?.triggeredConfiguration.configurationTemplateId ===
                    id,
        );
        const message = (
            <>
                {usedBy.length > 0 && (
                    <>
                        <p>
                            This configuration is in use by {usedBy.length}{" "}
                            event
                            {usedBy.length > 1 ? "s" : ""}:
                        </p>
                        <ul>
                            {usedBy.map(({ message: m }, i) => (
                                <li key={i}>{m}</li>
                            ))}
                        </ul>
                        <p>
                            Events will continue to use this configuration even
                            if it is deleted.
                        </p>
                    </>
                )}
                <p>Delete configuration "{name}"?</p>
            </>
        );
        appStore.setConfirm({
            title: "Delete configuration",
            message,
            onOk: async () => {
                await deviceConfigurationTemplateStore.disable(defined(id));
                appStore.setSnackbar("Configuration deleted");
            },
        });
    };

    private onApply = async () => {
        const id = defined(this.props.deviceConfigurationTemplate.id);
        const { navigate, routeTo } = routerStore;
        await navigate(routeTo.settings({}, { tab: "Devices", applyId: id }));
    };
}
